import { render } from "./TablesContent.vue?vue&type=template&id=7def1a4e"
import script from "./TablesContent.vue?vue&type=script&lang=js"
export * from "./TablesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__